<template>
  <li role="listitem"><router-link :to="{name: route}" class="usc-sidenav--item" exact-active-class="usc-sidenav--item__active">
    <slot></slot>
  </router-link></li>
</template>

<script>
export default {
  name: 'usc-sidenav-item',
  props: ['route']
}
</script>

<style lang="scss">
@import '~styles/vars';
@import '~styles/mixins';

@mixin sidenav_color($suffix, $color) {
  &_#{$suffix} {
    .usc-sidenav--items .usc-sidenav--item.usc-sidenav--item__active {
      position: relative;
      color: $color;
      &:after {
        transform: translate(0, 0);
        background-color: $color;
      }
    }
  }
}
.usc-sidenav--section {
  @include sidenav_color('intro', $cIntro);
  @include sidenav_color('academics', $cAcademics);
  @include sidenav_color('opportunities', $cOpportunities);
  @include sidenav_color('life', $cLife);
  @include sidenav_color('next_steps', $cNextSteps);
  @include sidenav_color('resources', $cResources);
}
.usc-sidenav--item {
  display: block;
  padding: 10px 34px 10px 0;
  border-right: none;
  color: #fff;
  text-decoration: none;
  // opacity: .5;
  // color: #7F7F7F !important;
  transition: .3s color;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  &::after {
    right: 0;
    transform: translate(6px, 0);
    content: '';
    display: block;
    position: absolute;
    width: 6px;
    height: 100%;
    top: 0;
    transition: .3s transform;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  &:hover, &.usc-sidenav--item__active {
    // opacity: 1;
    color: #FFF !important;
    &::after {
      transition: .3s transform;
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sidenav/SidenavItem.vue